// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/kubernetes/v1/resourcequota.proto (package chalk.kubernetes.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { KubernetesResourceQuantities } from "./resourcequantities_pb";
import { file_chalk_kubernetes_v1_resourcequantities } from "./resourcequantities_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/kubernetes/v1/resourcequota.proto.
 */
export const file_chalk_kubernetes_v1_resourcequota: GenFile = /*@__PURE__*/
  fileDesc("CidjaGFsay9rdWJlcm5ldGVzL3YxL3Jlc291cmNlcXVvdGEucHJvdG8SE2NoYWxrLmt1YmVybmV0ZXMudjEiqAEKHUt1YmVybmV0ZXNSZXNvdXJjZVF1b3RhU3RhdHVzEkYKC2hhcmRfbGltaXRzGAEgASgLMjEuY2hhbGsua3ViZXJuZXRlcy52MS5LdWJlcm5ldGVzUmVzb3VyY2VRdWFudGl0aWVzEj8KBHVzZWQYAiABKAsyMS5jaGFsay5rdWJlcm5ldGVzLnYxLkt1YmVybmV0ZXNSZXNvdXJjZVF1YW50aXRpZXMiZQobS3ViZXJuZXRlc1Jlc291cmNlUXVvdGFTcGVjEkYKC2hhcmRfbGltaXRzGAEgASgLMjEuY2hhbGsua3ViZXJuZXRlcy52MS5LdWJlcm5ldGVzUmVzb3VyY2VRdWFudGl0aWVzIr8BChtLdWJlcm5ldGVzUmVzb3VyY2VRdW90YURhdGESQwoEc3BlYxgCIAEoCzIwLmNoYWxrLmt1YmVybmV0ZXMudjEuS3ViZXJuZXRlc1Jlc291cmNlUXVvdGFTcGVjSACIAQESRwoGc3RhdHVzGAMgASgLMjIuY2hhbGsua3ViZXJuZXRlcy52MS5LdWJlcm5ldGVzUmVzb3VyY2VRdW90YVN0YXR1c0gBiAEBQgcKBV9zcGVjQgkKB19zdGF0dXNCHFoaa3ViZXJuZXRlcy92MTtrdWJlcm5ldGVzdjFiBnByb3RvMw", [file_chalk_kubernetes_v1_resourcequantities]);

/**
 * @generated from message chalk.kubernetes.v1.KubernetesResourceQuotaStatus
 */
export type KubernetesResourceQuotaStatus = Message<"chalk.kubernetes.v1.KubernetesResourceQuotaStatus"> & {
  /**
   * Hard is the set of enforced hard limits for each named resource.
   * More info: https://kubernetes.io/docs/concepts/policy/resource-quotas/
   * +optional
   *
   * @generated from field: chalk.kubernetes.v1.KubernetesResourceQuantities hard_limits = 1;
   */
  hardLimits?: KubernetesResourceQuantities;

  /**
   * Used is the current observed total usage of the resource in the namespace.
   * +optional
   *
   * @generated from field: chalk.kubernetes.v1.KubernetesResourceQuantities used = 2;
   */
  used?: KubernetesResourceQuantities;
};

/**
 * Describes the message chalk.kubernetes.v1.KubernetesResourceQuotaStatus.
 * Use `create(KubernetesResourceQuotaStatusSchema)` to create a new message.
 */
export const KubernetesResourceQuotaStatusSchema: GenMessage<KubernetesResourceQuotaStatus> = /*@__PURE__*/
  messageDesc(file_chalk_kubernetes_v1_resourcequota, 0);

/**
 * @generated from message chalk.kubernetes.v1.KubernetesResourceQuotaSpec
 */
export type KubernetesResourceQuotaSpec = Message<"chalk.kubernetes.v1.KubernetesResourceQuotaSpec"> & {
  /**
   * @generated from field: chalk.kubernetes.v1.KubernetesResourceQuantities hard_limits = 1;
   */
  hardLimits?: KubernetesResourceQuantities;
};

/**
 * Describes the message chalk.kubernetes.v1.KubernetesResourceQuotaSpec.
 * Use `create(KubernetesResourceQuotaSpecSchema)` to create a new message.
 */
export const KubernetesResourceQuotaSpecSchema: GenMessage<KubernetesResourceQuotaSpec> = /*@__PURE__*/
  messageDesc(file_chalk_kubernetes_v1_resourcequota, 1);

/**
 * @generated from message chalk.kubernetes.v1.KubernetesResourceQuotaData
 */
export type KubernetesResourceQuotaData = Message<"chalk.kubernetes.v1.KubernetesResourceQuotaData"> & {
  /**
   * Spec defines the desired quota.
   * https://git.k8s.io/community/contributors/devel/sig-architecture/api-conventions.md#spec-and-status
   * +optional
   *
   * @generated from field: optional chalk.kubernetes.v1.KubernetesResourceQuotaSpec spec = 2;
   */
  spec?: KubernetesResourceQuotaSpec;

  /**
   * Status defines the actual enforced quota and its current usage.
   * https://git.k8s.io/community/contributors/devel/sig-architecture/api-conventions.md#spec-and-status
   * +optional
   *
   * @generated from field: optional chalk.kubernetes.v1.KubernetesResourceQuotaStatus status = 3;
   */
  status?: KubernetesResourceQuotaStatus;
};

/**
 * Describes the message chalk.kubernetes.v1.KubernetesResourceQuotaData.
 * Use `create(KubernetesResourceQuotaDataSchema)` to create a new message.
 */
export const KubernetesResourceQuotaDataSchema: GenMessage<KubernetesResourceQuotaData> = /*@__PURE__*/
  messageDesc(file_chalk_kubernetes_v1_resourcequota, 2);

